<template>
	<!-- 宿舍楼栋 -->
	<div class="fuzzy-matching-box">
		<div class="fuzzy-matching-top">
			<el-form @keyup.native.enter="inquiryClick">
				<el-row class="top-first-line">
					<el-col :span="5">
						<el-form-item label="名称:">
							<el-input v-model="Dform.name" placeholder='请输入名称'></el-input>
						</el-form-item>
					</el-col>
					<el-button type="primary" class="query-button" @click="inquiryClick">查询</el-button>
					<el-button type="primary" class="query-button" @click="addLouDong">新增楼栋</el-button>
				</el-row>

			</el-form>
		</div>


		<!-- table表格 -->
		<div class="Table-Bottom">
			<el-table v-loading="loading" stripe :border="true"
				:header-cell-style="{ background: '#EDF6FF', color: '#000', height: '40px' }" ref="multipleTable"
				:data="tableData" tooltip-effect="dark" style="width: 100%" @selection-change="handleSelectionChange">
				<el-table-column type="selection" width="55">
				</el-table-column>
				<el-table-column type="index" label="序号" width="100">
				</el-table-column>

				<el-table-column prop="name" label="楼栋名称" show-overflow-tooltip>
				</el-table-column>
                <!-- <el-table-column prop="name" label="房间数" show-overflow-tooltip>
				</el-table-column>
                <el-table-column prop="name" label="已住学生" show-overflow-tooltip>
				</el-table-column> -->
				<el-table-column prop="created" label="添加时间" show-overflow-tooltip>
				</el-table-column>


				<el-table-column label="操作" min-width="100">
					<template #default="scope">
						<el-button class="textButton" type="text" size="small"
							@click="alterAdd(scope.row)">修改</el-button>
						<!-- <el-button class="textButton" type="text" size="small" @click="statusClick(scope.row)" v-if="scope.row.status == 1">加入黑名单</el-button> -->
						<el-button class="shanchuBtn" type="text" @click="tishiDelete(scope.row)">删除</el-button>

					</template>
				</el-table-column>
			</el-table>
			<!-- <div style="margin-top: 20px">
				<el-button @click="deleteClick">批量删除</el-button>
			</div> -->
		
            <div class="block-fenye">
             <el-pagination :small="small" :disabled="disabled" :background="background" layout="prev, pager, next, jumper"
               :total="total" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
           </div>
		</div>
        <Add v-if="AddShow" :detailsObj='detailsObj' @AddShowClick="AddShowClick"></Add>

	</div>
</template>
<!--  -->
<script>
	import {
		LoDongBuildingList,
        LoDongBuildingDelete
	} from '@/assets/api/schoollog.js'
    import {
		findTeacherInfo,
	} from '@/assets/api/renyuan';
    import Add from './child/add.vue';
	export default {
		components: {
            Add,

		},
		data() {
			return {
				AddShow: false,
				Dform: {
					name: ''
				},

				pageInfo: {
					page: 1,
					pageSize: 10,
				},
				multipleSelection: [],
                schoolInfo:{},
				tableData: [],
                detailsObj:{},
				total: 0,
				twigMax: 0,
				twigMin: 0,
				loading:true
			
			}
		},
		created() {
			this.Lookteacher()
			// this.menuGetUserTreeGet()
		},
		methods: {
           // 查看学校id 
            Lookteacher() {
                let params = {
                    userId: JSON.parse(localStorage.getItem('user')).id,
                }
                findTeacherInfo(params).then((res) => {
                    this.schoolInfo = res.data.data
                    this.getList()
                }).catch((err) => {
                    console.log(err);
                })
            },
            getList(){
                let params = {
                    schoolId: this.schoolInfo.schoolId,
                    name:this.Dform.name,
                    page:this.pageInfo.page,
                    pageSize:this.pageInfo.pageSize,
                }
                LoDongBuildingList(params).then((res) => {
                    this.tableData = res.data.data.list
                    this.total = res.data.data.total
					this.loading = false
                }).catch((err) => {
                    console.log(err);
                })

            },
            //新增楼栋
            addLouDong(){
				if (this.schoolInfo.schoolId) {
					this.detailsObj = {}
              		this.AddShow = true
				}else{
					this.$message({
						message: '该账号没有权限，请登录学校账号！',
						type: 'warning'
					});
				}
                
            },
            AddShowClick(){
                this.AddShow = false
                this.getList()

            },
            alterAdd(item){
                this.detailsObj = item
                this.AddShow = true
            },

			inquiryClick() {
				// this.pageInfo.page = 1
                this.getList()
			},


			deleteClick() {
				if (!this.multipleSelection.length) {
					ElMessage.error('请先选中需要删除的终端。')
				} else {
					let arr = []
					for (let value of this.multipleSelection) {
						console.log(value.memberId, 5555555);
						arr.push(value.memberId)
					}
					let params = {
						userId: JSON.parse(localStorage.getItem('user')).id,
						ids: arr
					}
					memberDelete(params).then((res) => {
						console.log(res, '删除接口');
						// this.searchClick()
						ElMessage({
							message: '删除成功',
							type: 'success',
						})
						this.multipleSelection = []
						this.memberListSearch()
					}).catch((err) => {
						console.log(err);
					})
				}
			},
			singleDeleteClick(item) {
                console.log(item,'删除');
                
				LoDongBuildingDelete(item.id).then((res) => {
					this.$message({
							type: 'success',
							message: '删除成功!'
						});
					this.getList()
				}).catch((err) => {
					// console.log(err);
					this.$message({
							type: 'error',
							message:err.response.data.msg
						});
				})
			},
			tishiDelete(item) {
					this.$confirm('请确认是否删除该楼栋!', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						this.singleDeleteClick(item)
						
					}).catch((err) => {
						console.log(err, '关机');
						
					});
			},

			handleSizeChange(val) {
				console.log(`每页 ${val} 条`);
			},
			handleCurrentChange(val) {
				console.log(`当前页: ${val}`);
				this.pageInfo.page = val
				this.memberListSearch()
			},

		}
	}
</script>

<!-- porimse -->
<style scoped lang="scss">
	.fuzzy-matching-box {
		padding-top: 40px;
		// overflow: hidden;
		// overflow: auto;
		width: 100%;
		height: 95%;
		background-color: #fff;
		border-radius: 8px;
		.fuzzy-matching-top {
			// height: 120px ;
			background-color: #fff;
			border-radius: 8px;

			.top-first-line {
				/deep/ {
					.el-form-item--small .el-form-item__label {
						// background-color: red;
						font-size: 16px;
					}

					.el-select--small {
						width: 100%
					}

					.el-form-item--small .el-form-item__label {
						width: 110px;
						text-align: right;
						height: 35px;
						line-height: 35px;
						font-weight: 700;
					}

					.el-input {
						width: 100%;
						height: 35px;
					}

					.el-button--small {
						width: 50px;
						height: 30px;
						margin-left: 20px;
						margin-top: 3px;
					}

					.el-select--small .el-select__wrapper {
						height: 35px !important;
					}
				}


			}

			.the-second-line {
				margin-top: 15px;
				position: relative;

				.query-button {
					position: absolute;
					right: 800px;
					// padding: 16px 24px;
					width: 50px;
					height: 50px !important;
					// top: 50%;
					// transform: translate(0,-50%);
				}
			}

			/deep/ {
				.el-range-editor--small.el-input__wrapper {
					height: 35px;
					line-height: 35px;
				}

			}

			.el-button--text {
				margin-left: 50px;
				margin-top: 10px;
				font-size: 16px;
			}
		}

        .block-fenye {
        // float: right;
            position: absolute;
            //   bottom: 0px;
            right:10%;
            top: 85%;
            transform: translate(-50%, 0);

        }
		.Table-Bottom {
			height: calc(100% - 30px);
			overflow: auto;
			// position: relative;
			padding: 0px 20px;
			padding-top: 20px;
			// margin-top: 15px;
			border-radius: 8px;

			/deep/ {
				.el-table .cell {
					// font-size: 15px;
					font-size: 16px;
					color: black;
					// font-weight: 700;
					text-align: center;
                    height: 30px;
                    line-height: 30px;
				}

				.el-table th.el-table__cell>.cell {
					font-weight: 700;
				}
			}

			.textButton {
				// background-color: pink;
				margin: 2px;
				padding: 0px;
				font-size: 15px;
				font-weight: 700;

			}

			.shanchuBtn {
				margin: 2px;
				padding: 0px;
				font-size: 15px;
				font-weight: 700;
				color: red;
			}
		}

		
	}
</style>